import { useLocation } from 'react-router-dom'
import { usePreferencesContext } from '../services'
import { useFeatureFlags } from './use-feature-flags'
import { ACCOUNT_DETAILS_TAB_VALUES } from '../utils/constants'
import { Flags } from '../utils/feature-flags'
import {
  STKRedirectLocationState,
  StkTabPreferencesData,
  StkTab,
  STKDeeplinkScenarios,
} from '../types'

export const useStkInitialTab = (): StkTab => {
  const { preferences } = usePreferencesContext()

  /* Override tab FF if we're coming from a deeplink - always show activity */
  const { state: locationState } = useLocation<STKRedirectLocationState>()
  /* istanbul ignore next */
  const fromDeeplinkRedirect = !!locationState?.deeplink
  const ffDefaultTab = useFeatureFlags(Flags.StkDefaultTab)

  const tabPreference = (
    preferences.savingsPreferences.data as StkTabPreferencesData
  ).currentTab as string
  // if user has any value set besides what is expected, use the feature flag default tab
  /* istanbul ignore next */
  const validTab = ACCOUNT_DETAILS_TAB_VALUES.includes(tabPreference)
    ? tabPreference
    : ffDefaultTab

  if (fromDeeplinkRedirect) {
    switch (locationState.deeplink) {
      case STKDeeplinkScenarios.Buckets: {
        return 'buckets'
      }
      case STKDeeplinkScenarios.Boosters: {
        return 'boosters'
      }
      case STKDeeplinkScenarios.RUP: {
        return 'boosters'
      }
      default: {
        return 'activity'
      }
    }
  } else {
    return validTab
  }
}
